import * as r from "react";
import a from "../lib/IconBase.es.js";
import m from "../defs/ArrowSquareOut.es.js";
const o = r.forwardRef((e, t) => /* @__PURE__ */ r.createElement(a, { ref: t, ...e, weights: m }));
o.displayName = "ArrowSquareOutIcon";
const n = o;
export {
  n as ArrowSquareOut,
  o as ArrowSquareOutIcon
};
